import React from "react"
import {Box, Button} from "@material-ui/core"
import AddIcon from "@material-ui/icons/Add"

import {CreateOfferModal} from "./CreateOfferModal"

type CustomerOffersProps = {
	customerID: string
	reload: () => void
}

function CustomerOffers({customerID, reload}: CustomerOffersProps) {
	const [createModalOpen, setCreateModalOpen] = React.useState(false)

	return (
		<Box p={3}>
			<Box display="flex" justifyContent="flex-end" mb={2}>
				<Button
					variant="contained"
					color="primary"
					startIcon={<AddIcon />}
					onClick={() => setCreateModalOpen(true)}
				>
					Create Offer
				</Button>
			</Box>

			<Box>
				{/* TODO: Implement offers list */}
				<p>Offers list will be implemented here</p>
			</Box>

			{createModalOpen && (
				<CreateOfferModal
					customerID={customerID}
					open={createModalOpen}
					onClose={() => setCreateModalOpen(false)}
					onSuccess={() => {
						setCreateModalOpen(false)
						reload()
					}}
				/>
			)}
		</Box>
	)
}

export {CustomerOffers}
